// Elite Theme — Tejoré

document.addEventListener('DOMContentLoaded', function () {

  // ── Fragrance Explorer mood filter ──────────────────────────────────────
  var tabs  = document.querySelectorAll('.ftag[data-mood]');
  var cards = document.querySelectorAll('.fcard[data-mood]');

  tabs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      tabs.forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
      var mood = btn.dataset.mood;
      cards.forEach(function (card) {
        card.style.display = (mood === 'all' || card.dataset.mood === mood) ? '' : 'none';
      });
    });
  });

  // ── Cart drawer ──────────────────────────────────────────────────────────
  var cartDrawer   = document.getElementById('cart-drawer');
  var cartOverlay  = document.getElementById('cart-overlay');
  var cartCloseBtn = document.getElementById('cart-close');
  var cartItemsEl  = document.getElementById('cart-items');
  var cartItemsWrap= document.getElementById('cart-items-wrap');
  var cartEmptyEl  = document.getElementById('cart-empty');
  var cartFootEl   = document.getElementById('cart-foot');
  var cartCountEl  = document.getElementById('cart-item-count');
  var cartSubEl    = document.getElementById('cart-subtotal');
  var cartTotalEl  = document.getElementById('cart-total-display');
  var cartFreeShip = document.getElementById('cart-free-ship');
  var navCartCount = document.querySelector('.elite-nav-icons span');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function renderCart(cart) {
    var count = cart.item_count;
    if (cartCountEl)  cartCountEl.textContent  = count;
    if (navCartCount) navCartCount.textContent  = count;

    var total = formatMoney(cart.total_price);
    if (cartSubEl)   cartSubEl.textContent   = total;
    if (cartTotalEl) cartTotalEl.textContent  = total;

    // Free shipping banner
    if (cartFreeShip) {
      var threshold = 99900;
      if (cart.total_price >= threshold) {
        cartFreeShip.textContent = 'Hurray! You get free shipping with this order.';
      } else {
        cartFreeShip.textContent = 'Add ' + formatMoney(threshold - cart.total_price) + ' more for free shipping.';
      }
      cartFreeShip.style.display = '';
    }

    if (count === 0) {
      if (cartItemsWrap) cartItemsWrap.style.display = 'none';
      if (cartEmptyEl)  { cartEmptyEl.style.display  = '';    }
      if (cartFootEl)   cartFootEl.style.display  = 'none';
      return;
    }

    if (cartItemsWrap) cartItemsWrap.style.display = '';
    if (cartEmptyEl)  cartEmptyEl.style.display  = 'none';
    if (cartFootEl)   cartFootEl.style.display   = '';

    if (!cartItemsEl) return;
    cartItemsEl.innerHTML = cart.items.map(function (item, i) {
      var imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.split('?')[0] + '?width=176'
        : '';
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '';
      var lineIndex = i + 1;
      return (
        '<div class="cart-item" data-line="' + lineIndex + '">' +
          (imgSrc ? '<img class="cart-item-img" src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">' : '<div class="cart-item-img"></div>') +
          '<div>' +
            '<p class="cart-item-title">' + item.product_title + '</p>' +
            variantLabel +
            '<p class="cart-item-price">' + formatMoney(item.final_line_price) + '</p>' +
            '<div class="cart-item-qty">' +
              '<button class="cart-item-qty-btn" data-line="' + lineIndex + '" data-delta="-1">&#8722;</button>' +
              '<div class="cart-item-qty-num">' + item.quantity + '</div>' +
              '<button class="cart-item-qty-btn" data-line="' + lineIndex + '" data-delta="1">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item-remove" data-line="' + lineIndex + '" aria-label="Remove"><i class="ti ti-trash"></i></button>' +
        '</div>'
      );
    }).join('');

    // Qty buttons
    cartItemsEl.querySelectorAll('.cart-item-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line   = parseInt(btn.dataset.line, 10);
        var row    = cartItemsEl.querySelector('.cart-item[data-line="' + line + '"]');
        var curQty = row ? parseInt(row.querySelector('.cart-item-qty-num').textContent, 10) : 1;
        var newQty = Math.max(0, curQty + parseInt(btn.dataset.delta, 10));
        changeCartLine(line, newQty);
      });
    });

    // Remove buttons
    cartItemsEl.querySelectorAll('.cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartLine(parseInt(btn.dataset.line, 10), 0);
      });
    });
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); });
  }

  function addToCart(variantId, btnEl) {
    if (btnEl) { btnEl.textContent = '···'; btnEl.style.pointerEvents = 'none'; }
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () { openCartDrawer(); })
    .catch(function () {})
    .finally(function () {
      if (btnEl) { btnEl.textContent = 'Quick add'; btnEl.style.pointerEvents = ''; }
    });
  }

  // Cart overlay & close
  if (cartOverlay)  cartOverlay.addEventListener('click',  closeCartDrawer);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);

  // Nav cart icon → open drawer
  var navCartLink = document.querySelector('.elite-nav-icons a[href*="cart"]');
  if (navCartLink) {
    navCartLink.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // Quick add buttons
  document.querySelectorAll('.qadd').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = el.dataset.variantId;
      if (vid) addToCart(parseInt(vid, 10), el);
    });
  });

  // ── Product image gallery ────────────────────────────────────────────────
  var mainImg    = document.getElementById('prod-main-img');
  var thumbs     = document.querySelectorAll('.prod-thumb');
  var galWrap    = document.getElementById('prod-gallery-main');
  var galCurrent = 0;
  var galTimer   = null;

  function galShow(index) {
    if (!thumbs.length || !mainImg) return;
    galCurrent = (index + thumbs.length) % thumbs.length;
    var thumb = thumbs[galCurrent];
    if (thumb.dataset.src) {
      mainImg.style.opacity = '0';
      mainImg.removeAttribute('srcset');
      mainImg.src = thumb.dataset.src;
      mainImg.onload = function () { mainImg.style.opacity = '1'; };
    }
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function galStartAuto() {
    if (thumbs.length < 2) return;
    galTimer = setInterval(function () { galShow(galCurrent + 1); }, 3000);
  }

  function galStopAuto() {
    clearInterval(galTimer);
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      galStopAuto();
      galShow(i);
      galStartAuto();
    });
  });

  // Pause on hover
  if (galWrap) {
    galWrap.addEventListener('mouseenter', galStopAuto);
    galWrap.addEventListener('mouseleave', galStartAuto);
  }

  galStartAuto();

  // ── Product page Add to Cart (AJAX → cart drawer) ───────────────────────
  var atcForm = document.getElementById('prod-atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var varId  = document.getElementById('prod-variant-id');
      var qtyInp = atcForm.querySelector('.prod-qty-input');
      var qty    = qtyInp ? parseInt(qtyInp.value, 10) || 1 : 1;
      var btn    = document.getElementById('prod-atc-btn');
      if (!varId) return;
      if (btn) { btn.textContent = '···'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: parseInt(varId.value, 10), quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () { openCartDrawer(); })
      .catch(function () {})
      .finally(function () {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      });
    });
  }

  // ── Variant selection ────────────────────────────────────────────────────
  var variantBtns   = document.querySelectorAll('.prod-variant-btn');
  var variantInput  = document.getElementById('prod-variant-id');
  var priceEl       = document.querySelector('.prod-price');
  var compareEl     = document.getElementById('prod-compare-price');
  var selectedLabel = document.getElementById('prod-selected-opt');
  var atcBtn        = document.getElementById('prod-atc-btn');

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.classList.contains('disabled')) return;

      variantBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      if (variantInput) variantInput.value = btn.dataset.variantId;
      if (priceEl)      priceEl.textContent = btn.dataset.price;
      if (selectedLabel) selectedLabel.textContent = '— ' + btn.dataset.title;

      if (compareEl) {
        if (btn.dataset.comparePrice) {
          compareEl.textContent = btn.dataset.comparePrice;
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (atcBtn) {
        var available = !btn.classList.contains('disabled');
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      // Switch main image to variant image
      if (btn.dataset.image && mainImg) {
        mainImg.style.opacity = '0';
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.dataset.image;
        mainImg.onload = function () { mainImg.style.opacity = '1'; };

        // Sync active thumbnail
        var pos = btn.dataset.imagePosition;
        if (pos) {
          thumbs.forEach(function (t) {
            t.classList.toggle('active', t.dataset.position === pos);
          });
        }
      }
    });
  });

  // ── Quantity +/- ─────────────────────────────────────────────────────────
  var qtyInput = document.querySelector('.prod-qty-input');
  var qtyMinus = document.querySelector('.prod-qty-minus');
  var qtyPlus  = document.querySelector('.prod-qty-plus');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  // ── Collection tabs bar scroll ───────────────────────────────────────────
  var tabsTrack = document.getElementById('coll-tabs-track');
  var tabsPrev  = document.getElementById('coll-tabs-prev');
  var tabsNext  = document.getElementById('coll-tabs-next');

  if (tabsTrack && tabsPrev && tabsNext) {
    tabsPrev.addEventListener('click', function () { tabsTrack.scrollLeft -= 280; });
    tabsNext.addEventListener('click', function () { tabsTrack.scrollLeft += 280; });
    // Scroll active tab into view on load
    var activeTab = tabsTrack.querySelector('.coll-tab.active');
    if (activeTab) activeTab.scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  // ── Collection subcategory strip scroll ─────────────────────────────────
  var track    = document.getElementById('coll-subcat-track');
  var prevBtn  = document.getElementById('coll-prev');
  var nextBtn  = document.getElementById('coll-next');

  if (track && prevBtn && nextBtn) {
    var scrollAmt = 300;
    prevBtn.addEventListener('click', function () { track.scrollLeft -= scrollAmt; });
    nextBtn.addEventListener('click', function () { track.scrollLeft += scrollAmt; });
  }

  // ── Collection filter panel toggle ───────────────────────────────────────
  var filterBtn   = document.getElementById('coll-filter-toggle');
  var filterPanel = document.getElementById('coll-filter-panel');

  if (filterBtn && filterPanel) {
    filterBtn.addEventListener('click', function () {
      var isOpen = filterPanel.classList.toggle('open');
      filterBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // ── Accordions ───────────────────────────────────────────────────────────
  var triggers = document.querySelectorAll('.prod-accord-trigger');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var body   = trigger.nextElementSibling;
      var isOpen = trigger.classList.contains('open');

      // close all first
      triggers.forEach(function (t) {
        t.classList.remove('open');
        t.setAttribute('aria-expanded', 'false');
        if (t.nextElementSibling) t.nextElementSibling.classList.remove('open');
      });

      // open this one if it was closed
      if (!isOpen) {
        trigger.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
        if (body) body.classList.add('open');
      }
    });
  });

    // ── Hero carousel ───────────────────────────────────────────────
  var hero = document.getElementById('elite-hero-carousel');

  if (hero) {
    var slides = hero.querySelectorAll('.hero-slide');
    var dots = hero.querySelectorAll('.hero-dot');
    var prev = hero.querySelector('#hero-prev');
    var next = hero.querySelector('#hero-next');
    var current = 0;

    function showSlide(index) {
      if (!slides.length) return;

      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('active', i === current);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === current);
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        showSlide(current - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(current + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.dataset.index, 10));
      });
    });

    if (slides.length > 1) {
      setInterval(function () {
        showSlide(current + 1);
      }, 5000);
    }
  }

});
